<template>
  <div>
    <jodit-editor
      :model-value="modelValue"
      :config="config"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import { JoditEditor } from 'jodit-vue';
import 'jodit/es5/jodit.min.css';

export default {
  components: {
    JoditEditor,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      config: {
        readonly: false,
        toolbar: true,
        hidePoweredByJodit: true,
        buttons: [
          'bold',
          'italic',
          'underline',
          'ol',
          'ul',
          'link',
          'image',
        ],
      },
    };
  },
};
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
